import { render, staticRenderFns } from "./illustration_feedback_graditude_light.svg?vue&type=template&id=1dc134b2&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports